import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import EmojiPicker from "emoji-picker-react";

const EmojiReactPicker = ({ set, showEmoji, setShowEmoji, triggerRef }) => {
  const pickerRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0, opacity: 0 });

  const pickerWidth = 320;
  const pickerHeight = 350;
  const gap = 10;
  const screenPadding = 12;

  const addEmoji = (e) => set((prev) => prev + e.emoji);

  const updatePosition = () => {
    if (!showEmoji || !triggerRef.current) return;

    const rect = triggerRef.current.getBoundingClientRect();

    let left = rect.left + rect.width / 2 - pickerWidth / 2;
    let top = rect.bottom + gap;

    if (left < screenPadding) left = screenPadding;
    if (left + pickerWidth > window.innerWidth - screenPadding) left = window.innerWidth - pickerWidth - screenPadding;

    const spaceBelow = window.innerHeight - rect.bottom;
    const spaceAbove = rect.top;

    if (spaceBelow < pickerHeight + gap && spaceAbove > spaceBelow) top = rect.top - pickerHeight - gap;

    if (top < screenPadding) top = screenPadding;
    if (top + pickerHeight > window.innerHeight - screenPadding) top = window.innerHeight - pickerHeight - screenPadding;

    setPosition({ top, left, opacity: 1 });
  };

  useEffect(() => {
    if (!showEmoji) return;

    updatePosition();

    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [showEmoji, triggerRef]);

  useEffect(() => {
    if (!showEmoji) return;

    const handleClickOutside = (e) => {
      if (pickerRef.current && !pickerRef.current.contains(e.target) && triggerRef.current && !triggerRef.current.contains(e.target)) setShowEmoji(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showEmoji, setShowEmoji, triggerRef]);

  if (!showEmoji) return null;

  return ReactDOM.createPortal(
    <div
      ref={pickerRef}
      className="fixed z-[9999] overflow-hidden rounded-xl bg-white shadow-2xl transition-opacity duration-150 dark:bg-slate-900"
      style={{ top: position.top, left: position.left, width: pickerWidth, height: pickerHeight, maxWidth: "calc(100vw - 24px)", opacity: position.opacity }}
    >
      <EmojiPicker searchDisabled skinTonesDisabled onEmojiClick={addEmoji} maxCommonlyUsed={0} emojiStyle="apple" previewConfig={{ showPreview: false }} width="100%" height="100%" />
    </div>,
    document.body
  );
};

export default EmojiReactPicker;